import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';

export function NotFound() {
  return <MainLayout header="Nothing here (404)" />;
}
